// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"300":"todo","363":"clinics","557":"parts","992":"reports"}[chunkId] + "." + {"300":"97608151","363":"9d64f6ac","557":"c8c99114","992":"7776f14c"}[chunkId] + ".css";
};